import { useState } from 'react';

interface FAQItem {
  q: string;
  a: string;
}

interface SharedFAQProps {
  title?: string;
  faqs: FAQItem[];
}

export default function SharedFAQ({ title = 'Frequently Asked Questions', faqs }: SharedFAQProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-mic-line text-accent text-sm"></i>
            <span className="text-accent text-xs font-body font-semibold uppercase tracking-wider">Voice Search Optimized</span>
          </div>
          <h2 className="font-heading font-extrabold text-navy text-4xl mb-4">{title}</h2>
          <p className="text-gray-500 font-body text-base">Clear, direct answers to your most common questions.</p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, i) => (
            <div
              key={i}
              className={`rounded-2xl border overflow-hidden transition-all duration-200 ${
                openIdx === i ? 'border-accent/30 bg-white' : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
              >
                <span className="font-heading font-bold text-navy text-base pr-6 leading-snug">{item.q}</span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-all duration-200 ${openIdx === i ? 'bg-accent' : 'bg-gray-100'}`}>
                  <i className={`text-sm transition-all duration-200 ${openIdx === i ? 'ri-subtract-line text-navy' : 'ri-add-line text-gray-500'}`}></i>
                </div>
              </button>
              {openIdx === i && (
                <div className="px-7 pb-6">
                  <p className="text-gray-600 font-body text-sm leading-relaxed border-t border-gray-100 pt-4">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
